export const USER_UPDATE = 'USER_UPDATE';
export const TOKENS_UPDATE = 'TOKENS_UPDATE';
export const RESET_TOKEN = 'RESET_TOKEN';